
function getUserInfo() {
  let userInfo = localStorage.getItem('userInfo') || '{}'
  let data = JSON.parse(userInfo)
  if(!data.permissions) {
    data.permissions = []
  }
  return data
}

function getToken(){
  return sessionStorage.getItem("token") || localStorage.getItem("token") || ""
}

function getBreadStyle() {
  return JSON.parse(localStorage.getItem('breadStyle')) || {display: 'none'}
}

function getBreadList() {
  return JSON.parse(localStorage.getItem('breadList')) || []
}


export default {
  userInfo: getUserInfo(),
  token: getToken(),
  menu: [],
  subMenu:  [],
  breadStyle: getBreadStyle(),
  breadList: getBreadList(),
  globalLoading: {loading: false, tip:'加载中...'},
  showHeader: true,
  medcase: {
    info: {},
    symptoms:  [],
    input_diagnose: {},
    check_diagnose: {}
  },
  // 缓存症状取值
  symptomValueCache: {},
  symptomRelation: [],
  /* 症状选择完毕后，会将影响的症状更新到这里 */
  selectedSymptomRelation: {},
  zhuanbingValidateRule: {},
  zhuanbingValidate: false,
  zhuanbingConfPage: false,
  fileProgress: 0,
  zhixiaoyunBridge: {
    show: false,
    loading: false,
    data: {}
  }
}
